// extracted by mini-css-extract-plugin
export default {"Item":"printedBomBulletList-module_Item_x0hjt","BulletPoint":"printedBomBulletList-module_BulletPoint_Kf7oz"};